import { Card, Form } from "antd";
import React, { useEffect, useState } from "react";
import SeoForms from "../../components/SeoConfig/SeoForms";
import { SEOServices } from "../../Services/SEOServices";
import { notify } from "../../customs/NotifyProvider";

const HomePageSeo = () => {
  const [form] = Form.useForm();
  const [seoData, setSeoData] = useState(null); 

  const onFinish = async (values) => {
    try {
      const formattedVal = { ...values, page_id: 1 };

      let response;

      if (seoData?.id) {
        response = await SEOServices.updateSEODetails(
          seoData.id,
          formattedVal
        );
      }
      else {
        response = await SEOServices.addSEODetails(formattedVal);
      }

      if (response?.status) {
        notify.success(response.message);
        getPageSeo(); 
      } else {
        notify.error(response.message);
      }
    } catch (error) {
      console.error(error);
      notify.error("Something went wrong");
    }
  };

  const getPageSeo = async () => {
    try {
      const response = await SEOServices.getSEODetialById(1);

      if (response?.data?.length > 0) {
        const record = response.data[0];
        setSeoData(record);        // store existing record
        form.setFieldsValue(record); // populate form
      } else {
        setSeoData(null);
        form.resetFields();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getPageSeo();
  }, []);

  return (
    
    <Card title="Home Page SEO">
      <SeoForms form={form} onFinish={onFinish} />
    </Card>
  );
};

export default HomePageSeo;
